import { Mail, MessageCircle } from "lucide-react";
import { CONTACT_EMAIL, whatsappUrl } from "@/constants/site";

export const Footer = () => {
  return (
    <footer className="relative overflow-hidden bg-brand-ink text-white">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 pt-16 pb-10">
        <div className="grid md:grid-cols-2 gap-10">
          <div>
            <img
              src="/brand/logo-white.png"
              alt="MiMaquinaSegura.cl — Seguros para maquinaria, equipos y tecnología"
              className="h-14 sm:h-16 w-auto"
            />
            <p className="mt-5 max-w-sm text-white/70">
              Seguros para maquinaria agrícola, de construcción y minería, y equipos
              electrónicos. Cobertura completa con el respaldo de las principales aseguradoras
              de Chile.
            </p>
          </div>
          <div className="md:text-right">
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-white/50">Contacto</p>
            <a
              data-testid="footer-email"
              href={`mailto:${CONTACT_EMAIL}`}
              className="mt-4 inline-flex items-center gap-2 text-lg font-medium hover:text-brand-yellow transition-colors"
            >
              <Mail className="h-5 w-5" /> {CONTACT_EMAIL}
            </a>
            <div className="mt-4">
              <a
                data-testid="footer-whatsapp"
                href={whatsappUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full bg-brand-whatsapp px-5 py-2.5 font-semibold text-white transition-all hover:-translate-y-0.5 hover:shadow-lg"
              >
                <MessageCircle className="h-5 w-5" /> Escríbenos por WhatsApp
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-8 flex flex-col gap-3 text-sm text-white/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p>© {new Date().getFullYear()} MiMaquinaSegura.cl · Corredora de seguros</p>
            <p>Respaldados por BCI Seguros · SURA · Zurich · Reale · HDI · MAPFRE</p>
          </div>
          <p className="text-center sm:text-left text-white/40">
            Corredora inscrita en el Registro de Corredores de Seguros de la Comisión para el
            Mercado Financiero (CMF), Chile. · Datos protegidos · Cotizar es gratis y sin compromiso.
          </p>
        </div>
      </div>
    </footer>
  );
};
